import { forwardRef } from "react";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import ModeEditIcon from "@mui/icons-material/ModeEdit";
import { IRCAFishboneDiagramCategory } from "./RCAFishboneDiagramCategoryInterfaces";
import { useStyles } from "../../RCAFisboneDiagram.styles";
import UseFishboneDiagramCategories from "./useFishboneDiagramCategories";
import { Tooltip, Typography } from "@mui/material";
import { truncateLongText } from "utilities/utilities";
import { TRUNCATE_DESCRIPTION_LENGTH_FISHBONE_DIAGRAM } from "constants/constants";
import StarIcon from "@mui/icons-material/Star";

const RCAFishboneDiagramCategory = forwardRef<HTMLDivElement, IRCAFishboneDiagramCategory>((props, ref) => {
    const {
        name,
        xPosition,
        items,
        onComponentReady,
        onRemoveItem,
        onEditItem,
        onHighlightItem,
        position,
        category,
        onAddMainItem,
        onAddSecondaryItem,
    } = props;
    const classes = useStyles();
    const { totalHeight, finalItemsWithPositionValue, itemsRefs } = UseFishboneDiagramCategories({
        items,
        position,
        onComponentReady,
    });
    return (
        <div className={classes.category}>
            <div
                className={classes.verticalLine}
                style={{
                    left: `${xPosition}px`,
                    transform: position === "top" ? `translateY(-${totalHeight}px)` : `rotate(180deg)`,
                    height: totalHeight,
                }}
                ref={ref}
            >
                <div className={classes.verticalLineWrapper}>
                    <div className={position === "top" ? classes.categoryName : classes.categoryNameDown}>
                        <div className={classes.categoryNameWrapper}>
                            <div className={classes.categoryNameAddButton} onClick={() => onAddMainItem(category)}>
                                <AddIcon />
                            </div>
                            <span className={classes.categoryNameText}>{name}</span>
                        </div>
                    </div>
                    {finalItemsWithPositionValue.map((item, index) => {
                        return (
                            <div
                                key={item.fishbone_diagram_problem_cause_id}
                                data-id={item.fishbone_diagram_problem_cause_id}
                                className={
                                    item.primary_problem_cause_id
                                        ? item.is_highlighted
                                            ? classes.secondaryItemHighlighted
                                            : classes.secondaryItem
                                        : item.is_highlighted
                                        ? classes.mainItemHighlighted
                                        : classes.mainItem
                                }
                                ref={(element) => {
                                    if (element) {
                                        itemsRefs.current[index] = element;
                                    } else {
                                        delete itemsRefs.current[index];
                                    }
                                }}
                                style={{
                                    transform:
                                        position === "top" ? `translateX(-50%)` : `translateX(-50%) rotate(180deg)`,
                                    ...(position === "top" && { bottom: item.position || 0 }),
                                    ...(position === "bottom" && { top: item.position || 0 }),
                                }}
                            >
                                {!item.primary_problem_cause_id && (
                                    <div className={classes.itemAddButton} onClick={() => onAddSecondaryItem(item)}>
                                        <AddIcon />
                                    </div>
                                )}
                                {item.description.length >= TRUNCATE_DESCRIPTION_LENGTH_FISHBONE_DIAGRAM ? (
                                    <Tooltip
                                        PopperProps={{
                                            className: classes.tooltip,
                                        }}
                                        title={
                                            <Typography className={classes.tooltipTexts}>{item.description}</Typography>
                                        }
                                        placement="top-start"
                                    >
                                        <span
                                            className={
                                                item.primary_problem_cause_id
                                                    ? classes.secondaryItemText
                                                    : classes.mainItemText
                                            }
                                        >
                                            {truncateLongText(
                                                item.description,
                                                TRUNCATE_DESCRIPTION_LENGTH_FISHBONE_DIAGRAM,
                                            )}
                                        </span>
                                    </Tooltip>
                                ) : (
                                    <span
                                        className={
                                            item.primary_problem_cause_id
                                                ? classes.secondaryItemText
                                                : classes.mainItemText
                                        }
                                    >
                                        {item.description}
                                    </span>
                                )}

                                <div
                                    id="itemHighlightButton"
                                    className={
                                        item.is_highlighted
                                            ? classes.itemHighlightedButton
                                            : classes.itemHighlightButton
                                    }
                                    onClick={async () => await onHighlightItem(item)}
                                >
                                    <StarIcon />
                                </div>
                                <div
                                    id="itemDeleteButton"
                                    className={classes.itemDeleteButton}
                                    onClick={() => onRemoveItem(item)}
                                >
                                    <DeleteIcon />
                                </div>
                                <div
                                    id="itemEditButton"
                                    className={classes.itemEditButton}
                                    onClick={() => onEditItem(item)}
                                >
                                    <ModeEditIcon />
                                </div>
                            </div>
                        );
                    })}
                    <div className={classes.arrowDown}></div>
                </div>
            </div>
        </div>
    );
});

export default RCAFishboneDiagramCategory;
